import { Button } from "../../components/Button";
import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { STabs, STabList, STab, STabPanel } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import { useQuery } from "react-query";
import AddIcon from "../../assets/img/icons/add.svg";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import { Link } from "react-router-dom";
import moment from "moment";
import { QueryLoader } from "../../components/Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useState, useEffect } from "react";
import { SearchFilters } from "../../components/SearchFilters";
import { getSearchResult } from "../../api/search/search";
import { useSearchContext } from "../../context/search";
import { DecisionList } from "../../components/DecisionList/DecisionList";
import { DocumentUploadModal } from "../../components/DocumentUpload";
import UploadIcon from "../../assets/img/icons/upload.svg";
import useCurrentUser from "../../hooks/useCurrentUser";

export default function DashboardPage() {
	const {
		state: { filters },
	} = useSearchContext();
	const { axiosPrivate } = useAxiosPrivate();
	const { can } = useCurrentUser();
	const { isLoading, isError, error, data } = useQuery(["decisionsList", filters], () =>
		getSearchResult(axiosPrivate, undefined, false, filters)
	);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const safeData = Array.isArray(data) ? data : [];
	const withStatus = (status) => safeData.filter((d) => d.status.slug === status);
	const tabs = {
		draft: withStatus("draft"),
		ongoing: withStatus("ongoing"),
		done: withStatus("done"),
		archive: withStatus("archive"),
	};

	useEffect(() => {
		if (isError) console.log(error);
	}, [isError]);

	const handleUploadModalClose = () => {
		setIsUploadModalOpen(false);
	};

	const handleDecisionCreated = (decisionData) => {
		// This could trigger a refetch of decisions if needed
		console.log("Decision created from document:", decisionData);
	};

	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<div>
							<i>
								<img src={CalendarIcon} alt="Date" />
							</i>
							<span>{`${moment(new Date()).format("YYYY-MM-DD")}`}</span>
						</div>
					</StyledPageHeader>

					<StyledPageHeader>
						<h2>Decisions</h2>
						<div style={{ display: "flex", gap: "1rem" }}>
							{can("createDecisions") && (
								<Button icon={UploadIcon} onClick={() => setIsUploadModalOpen(true)} bg={true} initial={true}>
									Upload document
								</Button>
							)}
							{/* {Object.keys(items.userUnits).length !== 0 && (
								<Link to={"/add-decision"}>
									<Button icon={AddIcon}>Add new decision</Button>
								</Link>
							)} */}
						</div>
					</StyledPageHeader>
					<SearchFilters inline />
					{isLoading ? (
						<QueryLoader />
					) : isError ? (
						`Something went wrong. Please reload the page. ${error}`
					) : (
						Array.isArray(data) && (
							<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
								<STabList>
									<STab>Draft</STab>
									<STab>Ongoing</STab>
									<STab>Done</STab>
									<STab>Archive</STab>
								</STabList>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.draft} />
								</STabPanel>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.ongoing} />
								</STabPanel>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.done} />
								</STabPanel>
								<STabPanel>
									<DecisionList clearSearchResults={true} data={tabs.archive} />
								</STabPanel>
							</STabs>
						)
					)}
				</Col>
			</Row>

			<DocumentUploadModal
				isOpen={isUploadModalOpen}
				onClose={handleUploadModalClose}
				onDecisionCreated={handleDecisionCreated}
			/>
		</Container>
	);
}
